<div
  class="card"
  [ngClass]="{ paired: isPaired() }"
  (click)="navigateToProduct()"
>
  @if (product(); as product) {
  <img
    src="./assets/images/product-logos/{{ product.code }}-{{
      isPaired() ? 'blue' : 'white'
    }}.png"
    alt="{{ product.name }}"
    class="product-logo"
  />
  <div class="product-details">
    <h6>{{ product.name }}</h6>
    <p>{{ 'productsDescription.' + product.code | translate }}</p>
    @if (!isPaired()) {
    <div class="buttons">
      @if (allowList.includes(product.code)) {
      <button (click)="pairProduct()" mat-flat-button class="light-blue">
        {{ 'home.linkAccount' | translate }}
      </button>
      }
      <button (click)="navigateToLearnMore()" mat-flat-button>
        {{ 'home.learnMore' | translate }}
      </button>
    </div>
    }
  </div>
  @if (isPaired()) {
  <button
    mat-icon-button
    aria-label="unlink account"
    class="unlink"
    (click)="unpairProduct($event)"
  >
    <mat-icon>link_off</mat-icon>
  </button>
  } }
</div>
